export const DOCUMENTS_FIELDS = [
  'id',
  'name',
  'folder_id',
  'file_url',
  'mime_type',
]
